import { useEffect } from "react";

/**
 * Passes the candle colours and the shadow style to the engine: the saved
 * ones, or the preview while CandleColorsModal is open. They apply to
 * Candles, Bars and Heikin Ashi; the shadow style only to Candles and
 * Heikin Ashi (E18).
 *
 * @param {object|null} engine - ChartEngine, null until it is created
 * @param {{ settings: object }} chartSettingsApi - from useChartSettings
 * @param {{ candleUpColor: string, candleDownColor: string, shadowStyle: string } | null} preview
 *   - shown instead of the saved values while CandleColorsModal is open
 */
const useChartColors = (engine, chartSettingsApi, preview) => {
  const { candleUpColor, candleDownColor, shadowStyle } = preview ?? chartSettingsApi.settings;

  useEffect(() => {
    engine?.setSeriesStyle({ upColor: candleUpColor, downColor: candleDownColor, shadowStyle });
  }, [engine, candleUpColor, candleDownColor, shadowStyle]);
};

export default useChartColors;
